import { Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledReference = styled.span`
    color: ${Tokens.COLOURS.primary.orange[130]};
`;
